import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

import type { RecurringSetupDialogProps } from './types';

const RECURRING_SETUP_DIALOG = 'RECURRING_SETUP_DIALOG';
ImportModalComponent(RECURRING_SETUP_DIALOG, () => import('./index'));

export const dispatchRecurringSetupDialog = (props?: RecurringSetupDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: RECURRING_SETUP_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchRecurringSetupDialog;
